export enum BigRoundMode {
  roundDown = 0,
  roundHalfUp = 1,
  roundHalfEven = 2,
  roundUp = 3,
}
